import getApi from '../../api'
import { OrdoclicPrescriptionFile } from '../../model/ordoclic'

export type PrescriptionFilesPayload = Array<{
  ordoclicPatientId: string
  prescriptionIds: string[]
  medicalEventId?: number
}>

export const createPrescriptionFiles = (payload: PrescriptionFilesPayload) =>
  getApi().post<OrdoclicPrescriptionFile[]>('external_eprescription/files/batch', payload)
